import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';
import { Router          } from '@angular/router';
import { RoutingPages    } from '../enums/routing/routing-pages.enum';
import { SessionManager  } from '../managers/session/session.manager';

@Injectable
({
  providedIn: 'root'
})

export class Authentication 
{
    constructor(
      private _notifier : NotifierManager
    ) {}

    notAllowed () 
    {
      this._notifier.show(Notifier.ERROR, NotifierMessage.NOT_ALLOWED)
    }
}